<script setup lang="ts">
import {renderAssistantMarkdown} from './markdownRenderer'

defineProps<{
  content: string
}>()
</script>

<template>
  <div class="assistant-message-markdown" v-html="renderAssistantMarkdown(content)" />
</template>

<style scoped>
.assistant-message-markdown :deep(h1) {
  @apply my-2 text-lg font-semi-bold leading-tight tracking-normal normal-case text-new-primary-default;
}

.assistant-message-markdown :deep(h2) {
  @apply my-2 text-lg font-semi-bold leading-tight tracking-normal normal-case text-new-neutral-600;
}

.assistant-message-markdown :deep(h3),
.assistant-message-markdown :deep(h4),
.assistant-message-markdown :deep(h5),
.assistant-message-markdown :deep(h6) {
  @apply my-2 text-base font-semi-bold leading-tight tracking-normal normal-case text-new-neutral-600;
}

.assistant-message-markdown :deep(hr) {
  @apply my-3 border-0 border-t border-new-neutral-200;
}

.assistant-message-markdown :deep(ul) {
  @apply my-2 list-disc pl-5 marker:text-new-neutral-600;
}

.assistant-message-markdown :deep(ol) {
  @apply my-2 list-decimal pl-5 marker:text-new-neutral-600;
}

.assistant-message-markdown :deep(li) {
  @apply my-1;
}

.assistant-message-markdown :deep(p) {
  @apply p-2;
}

.assistant-message-markdown :deep(table) {
  @apply my-3 block w-max max-w-full text-left text-base border border-new-neutral-100 bg-new-neutral-0 rounded-new-xl overflow-x-auto;
}

.assistant-message-markdown :deep(thead) {
  @apply bg-new-neutral-100 text-new-primary-default;
}

.assistant-message-markdown :deep(th) {
  @apply px-3 py-2.5 font-semi-bold whitespace-nowrap;
}

.assistant-message-markdown :deep(tbody tr) {
  @apply border-t border-new-neutral-100 text-verydarkgrey;
}

.assistant-message-markdown :deep(tbody tr:nth-child(even)) {
  @apply bg-new-neutral-50;
}

.assistant-message-markdown :deep(tbody tr:nth-child(odd)) {
  @apply bg-white;
}

.assistant-message-markdown :deep(td) {
  @apply px-3 py-2.5 whitespace-nowrap;
}
</style>
